export const formatColumnName = (string: string) => {
  const formattedArray = string.split("_").map((value: string, index: number) => {
      return (value[0].toUpperCase() + value.substring(1))
  })

  return formattedArray.join(" ")
}